var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValijaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1025 7.8125H3.04004C1.74561 7.8125 0.696289 8.86182 0.696289 10.1562V21.0938C0.696289 22.3882 1.74561 23.4375 3.04004 23.4375H3.82129V24.2188C3.82129 24.6504 4.1709 25 4.60254 25H6.16504C6.59668 25 6.94629 24.6504 6.94629 24.2188V23.4375H13.1963V24.2188C13.1963 24.6504 13.5459 25 13.9775 25H15.54C15.9717 25 16.3213 24.6504 16.3213 24.2188V23.4375H17.1025C18.397 23.4375 19.4463 22.3882 19.4463 21.0938V10.1562C19.4463 8.86182 18.397 7.8125 17.1025 7.8125ZM16.3213 18.3594C16.3213 18.5752 16.1465 18.75 15.9307 18.75H4.21191C3.99609 18.75 3.82129 18.5752 3.82129 18.3594V17.5781C3.82129 17.3623 3.99609 17.1875 4.21191 17.1875H15.9307C16.1465 17.1875 16.3213 17.3623 16.3213 17.5781V18.3594ZM16.3213 13.6719C16.3213 13.8877 16.1465 14.0625 15.9307 14.0625H4.21191C3.99609 14.0625 3.82129 13.8877 3.82129 13.6719V12.8906C3.82129 12.6748 3.99609 12.5 4.21191 12.5H15.9307C16.1465 12.5 16.3213 12.6748 16.3213 12.8906V13.6719ZM7.72754 2.34375H12.415V6.25H14.7588V2.34375C14.7588 1.04932 13.7095 0 12.415 0H7.72754C6.43311 0 5.38379 1.04932 5.38379 2.34375V6.25H7.72754V2.34375Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValijaIcon);
export default __webpack_public_path__ + "static/media/valija_icon.2f3c8ea101a1d5e808b0dbb22415c763.svg";
export { ForwardRef as ReactComponent };